import React from "react";
import PersonDescription from "../components/PersonDescription";

const Person = () => {
  return (
    <div className="container has-fade fade-in">
      <PersonDescription />
    </div>
  );
};

export default Person;
